import { ExclamationCircleIcon } from "@heroicons/react/24/outline";

import { DEMO_MODE_FEATURE } from "../../constants/FeatureFlag";
import { FEATURE } from "../../constants/FeatureFlag";
import { staticLabelStore } from "../../utils/mobx/StaticLabelStore";

export default function FileSecurityWarning() {
  const { staticLabels } = staticLabelStore;

  return (
    FEATURE === DEMO_MODE_FEATURE &&
    staticLabels?.Common?.Message?.DemoSecurityWarning[1] && (
      <div className="detail flex gap-1 text-muted-foreground">
        <p>
          <ExclamationCircleIcon className="size-4" />
        </p>
        {staticLabels?.Common?.Message?.DemoSecurityWarning[0]}
      </div>
    )
  );
}
